import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Distributor.Save.IRequest;
type Response = Api.Core.Distributor.Save.IResponse;
type Headers = Api.Core.Distributor.Save.IHeaders;
const url = '/api/Sales/Distributor';
export default async function distributorSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
